import { ReduxSimpleActionInterface } from '@ecommerce/nest-ssr/dist/common';
import { CategoryUrlManagerInterface } from 'modules/categories/interfaces/category-url-manager.interface';
import { FILTERS_LIMIT } from 'modules/shared/components/filters/helpers/filters.const';

export enum FiltersActions {
    SET_FILTER = 'SET_FILTER',
    UNSET_FILTER = 'UNSET_FILTER',
    SET_PRICE = 'SET_PRICE',
}

export const categoryUrlParams = [
    (
        state: CategoryUrlManagerInterface,
        action: ReduxSimpleActionInterface<FiltersActions.SET_FILTER | FiltersActions.UNSET_FILTER, { id: string; }> |
            ReduxSimpleActionInterface<FiltersActions.SET_PRICE, { price: { min: number; max: number; };}>
    ): CategoryUrlManagerInterface => {
        switch (action.type) {
            case FiltersActions.SET_FILTER: {
                const filters = state.filters ?? [];

                if (filters.length >= FILTERS_LIMIT) {
                    return state;
                }

                return { ...state, page: 1, filters: [...filters, action.id] };
            }
            case FiltersActions.UNSET_FILTER:
                return { ...state, page: 1, filters: [...state.filters ?? []].filter(id => id !== action.id) };
            case FiltersActions.SET_PRICE:
                return { ...state, page: 1, price: { min: action.price.min, max: action.price.max } };
            default:
                return state;
        }
    }
];
